import styled from '@emotion/styled';
import { Breadcrumb, Divider, Image, Space } from 'antd';
import { FaHome } from 'react-icons/fa';
import { FiChevronRight } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../routes';
import { ORANGE, YELLOW } from '../../../shared/colors';
import { Footer } from '../../homePage/components/Footer';
import { Layout } from '../../shared/Layout';
import { SubmenuFormation } from '../components/Submenu';

const Container = styled.div`
  // height: calc(100vh - 32px);
  background-color: white;

  .banner {
    height: 300px;
    background-color: white;
    background-image: url('/assets/images/formation-banner.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 5% 15% 5% 15%;

    .bread-crumb {
      font-size: 14px;
      margin-top: 10px;

      span {
        color: white;
        font-family: Poppins-L;
      }

      .link {
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .menus {
      display: flex;

      > p {
        text-transform: uppercase;
        font-family: Poppins-L;
        font-size: 14px;
        padding: 13px 10px;
        margin-right: 15px;

        &:hover {
          background-color: ${YELLOW};
          cursor: pointer;
        }
      }

      .active {
        background-color: ${YELLOW};
      }
    }
  }

  > .content {
    min-height: 400px;
    background-color: white;
    color: black;
    padding: 2% 15%;

    > h2 {
      font-family: Poppins-B;
      font-size: 25px;
      margin-bottom: 15px;
    }

    > h3 {
      font-family: Poppins-B;
      // font-size: 25px;
      // margin-bottom: 15px;
    }

    > p {
      font-size: 16px;
    }
  }
`;

export const DefinitionPage = () => {
  const history = useHistory();

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <Space size={10}>
            <Image
              alt='moranje-logo'
              src='assets/images/moranje-logo.png'
              // height={250}
              width={130}
              preview={false}
              style={{ objectFit: 'contain', cursor: 'pointer' }}
            />
            <div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 35,
                }}
              >
                <span style={{ color: ORANGE }}>Moranj</span>
                <span style={{ color: '#6d4c41' }}>E</span>
                <span style={{ color: YELLOW }}>trade</span>
              </div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 30,
                }}
              >
                Formation
              </div>
            </div>
          </Space>
          <Breadcrumb separator='>' className='bread-crumb'>
            <Breadcrumb.Item>
              <FaHome style={{ marginRight: 5 }} />
              <span>Accueil</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item
              onClick={() => history.push(ROUTES.FORMATION.PAGE)}
            >
              <span className='link'>Formation</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Définitions</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

          <div className='menus'>
            {SubmenuFormation('1').map((form, i) => (
              <p
                className={form.color ? 'active' : ''}
                key={i}
                onClick={() => history.push(form.link)}
              >
                {form.label}
              </p>
            ))}
          </div>
        </div>

        <div className='content'>
          <h2>Définitions</h2>

          <h3>
            <FiChevronRight style={{ marginBottom: -2.5 }} />
            SPECIALISTES DES VALEURS DU TRESOR (SVT)
          </h3>
          <p>
            Les Spécialistes en Valeurs du Trésor (SVT) sont les contreparties
            privilégiées de l'AFT pour l'ensemble de ses activités sur les
            marchés. Ils conseillent et assistent l'agence sur sa politique
            d'émission et de gestion de la dette, et plus généralement sur toute
            question intéressant le bon fonctionnement des marchés.
          </p>

          <h3>
            <FiChevronRight style={{ marginBottom: -2.5 }} />
            OBLIGATIONS DU TRESOR ASSIMILABLES (OTA)
          </h3>
          <p>
            Les obligations du Trésor Assimilables (OTA) sont le support de
            l'endettement à moyen et long terme de l'État. La maturité de ces
            titres est comprise entre deux et sept ans. Les OTA sont à taux fixe
            et remboursables in fine, avec un capital éventuellement indexé sur
            l'inflation (cas des OTA en devise étrangère). Les OTA de long terme
            sont émises par adjudication ou xxxxx
          </p>

          <h3>
            <FiChevronRight style={{ marginBottom: -2.5 }} />
            BONS DE TRESOR ASSIMILABLES (BTA)
          </h3>
          <p>
            Les Bons de Trésor Assimilables (BTA) sont des titres de créances
            négociables émis par l'État. Ils sont cotés en pourcentage de leur
            valeur nominale et offrent un placement à court terme.Les bons du
            Trésor sont l'instrument de gestion de trésorerie de l'État. Ils
            servent à couvrir les fluctuations infra-annuelles de la trésorerie
            de l'État, qui découlent pour l'essentiel du décalage entre le
            rythme d'encaissement des recettes et celui du paiement des dépenses
            et de l'échéancier d'amortissement de la dette. La maturité des BTA
            à l'émission est de moins d'un an
          </p>

          <h3>
            <FiChevronRight style={{ marginBottom: -2.5 }} />
            EMPRUNTS OBLIGATAIRES
          </h3>
          <p>
            Un emprunt obligataire est une dette émise par une personne morale
            (entreprise privée, société publique, État ou collectivité publique)
            pour se financer auprès d'investisseurs, appelés obligataires. Les
            obligations sont des titres financiers assimilables à une dette pour
            l'entreprise qui émet les titres. Lors d'un emprunt obligataire,
            l'émetteur et le souscripteur signent un contrat obligataire pour
            formaliser le prêt qui fixe notamment la maturité et le taux
            d'intérêt. L'emprunt obligataire est une source de financement par
            émission de titres qui permet à toute entreprise de financer tout
            type de besoin à plus ou moins long terme.
            <br />
            Il existe plusieurs types d'emprunts obligataires : <br />
            <ul>
              <li>
                <b>Emprunts d'Etat : </b>Les Etats financent leurs dépenses à
                travers l'émission de titres.{' '}
              </li>
              <li>
                <b>Emprunts “corporate : </b>Les emprunts “corporate” désignent
                les emprunts issus d'entreprises privées. Ici, la rémunération
                sera proportionnelle à la qualité de signature des entreprises :
                plus celle-ci sera jugée solide, moins l'intérêt sera important
                (le risque étant plus faible).
              </li>
            </ul>
          </p>

          <h3>
            <FiChevronRight style={{ marginBottom: -2.5 }} />
            COUPON
          </h3>
          <p>
            Le taux d'intérêt fixe que l'émetteur de l'obligation s'engage à
            payer à l'investisseur chaque année.
          </p>

          <h3>
            <FiChevronRight style={{ marginBottom: -2.5 }} />
            OBLIGATIONS CONVERTIBLES (CONVERTIBLES BONDS)
          </h3>
          <p>
            Une obligation convertible est un titre de créance qui offre à son
            porteur le droit d'échanger l'obligation en actions de la société
            émettrice. Ce droit de conversion peut être exercé au cours d'une
            période déterminée et selon une parité de conversion fixée à
            l'avance. L'obligation convertible peut être remboursée soit en
            numéraire soit en actions à son échéance.
            <br />
            Il existe différents types d'obligations convertibles : <br />
            <ul>
              <li>
                L'obligation convertible vanille permet de convertir
                l'obligation en actions de la société émettrice, les parties
                ayant préalablement fixé un ratio de conversion qui définit le
                nombre d'actions auquel donne droit l'obligation
              </li>
              <li>
                L'obligation échangeable offre la possibilité d'échanger une
                obligation en actions différentes de celles de la société
                émettrice de l'obligation
              </li>
              <li>
                L'OCEANE permet d'échanger une obligation en actions dans le
                cadre d'une augmentation de capital ou d'une recapitalisation
              </li>
            </ul>
            Pour l'émetteur de l'obligation convertible, l'avantage, encaissable
            immédiatement, s'exprime sur le plan du coût de l'endettement par
            rapport à une émission d' obligations à taux fixe. En effet, toutes
            choses égales par ailleurs, les intérêts payés par l'émetteur sont
            plus faibles. La différence de coût correspond en quelque sorte à la
            valeur qui est attribuée au droit de conversion.
          </p>

          <h3>
            <FiChevronRight style={{ marginBottom: -2.5 }} />
            MATURITE
          </h3>
          <p>
            La date à laquelle le principal de l'obligation doit être remboursé
            à l'investisseur.
          </p>

          <h3>
            <FiChevronRight style={{ marginBottom: -2.5 }} />
            PRIME DE REMBOURSEMENT
          </h3>
          <p>
            Un montant supplémentaire que l'émetteur de l'obligation paie à
            l'investisseur lorsque le principal est remboursé.
          </p>

          <h3>
            <FiChevronRight style={{ marginBottom: -2.5 }} />
            RISQUE DE CREDIT
          </h3>
          <p>
            Le risque que l'émetteur de l'obligation ne soit pas en mesure de
            rembourser le principal ou de payer les intérêts à l'échéance.
          </p>

          <h3>
            <FiChevronRight style={{ marginBottom: -2.5 }} />
            RENDEMENT A MATURITE (YILED TO MATURITY (YTM))
          </h3>
          <p>
            Le taux de rendement total prévu sur une obligation si elle est
            détenue jusqu'à son échéance.
          </p>

          <h3>
            <FiChevronRight style={{ marginBottom: -2.5 }} />
            OBLIGATION ZERO COUPON
          </h3>
          <p>
            Une obligation qui ne paie pas d'intérêts périodiques mais est
            vendue avec une décote par rapport à sa valeur nominale.
          </p>
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};
